var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { memo } from 'react';
import { STAR_1_PATH, STAR_2_PATH, STAR_3_PATH, STAR_4_PATH, STAR_5_PATH, } from './paths';
import styled from 'styled-components';
var RatingContainer = styled.div({
    display: 'inline-flex',
    alignItems: 'center',
});
var RatingText = styled.span({
    marginLeft: '7.5px',
    fontSize: '15px',
    fontFamily: 'var(--font-family-primary)',
});
var getColor = function (value, min) {
    return value >= min ? '#ffc900' : '#d8d8d8';
};
export var Rating = memo(function (_a) {
    var value = _a.value;
    if (value < 1 || value > 5) {
        throw new Error("Expected value to be between 1 and 5, but received ".concat(value));
    }
    return (_jsxs(RatingContainer, { children: [_jsx("svg", __assign({ width: "122px", height: "20px", viewBox: "0 0 122 20" }, { children: _jsxs("g", { children: [_jsx("polygon", { fill: getColor(value, 1), points: STAR_1_PATH }, void 0), _jsx("polygon", { fill: getColor(value, 2), points: STAR_2_PATH }, void 0), _jsx("polygon", { fill: getColor(value, 3), points: STAR_3_PATH }, void 0), _jsx("polygon", { fill: getColor(value, 4), points: STAR_4_PATH }, void 0), _jsx("polygon", { fill: getColor(value, 5), points: STAR_5_PATH }, void 0)] }, void 0) }), void 0), _jsx(RatingText, { children: value }, void 0)] }, void 0));
});
